{
  "anchoring": {
    "nav": "Education",
    "title": "Education",
    "description": "Create quizzes for published documents and track who has completed them.",
    "tabs": {
      "unanchored": "Unanchored documents",
      "anchored": "Anchored documents",
      "mine": "Your quizzes"
    },
    "status": {
      "take": "Go to quiz",
      "completed": "Completed"
    },
    "manage": {
      "heading": "Quiz",
      "empty": "No quiz has been created for this document yet.",
      "create": "Create quiz",
      "createDescription": "Generate a quiz from this document. Add an optional prompt to focus the questions.",
      "creating": "Generating quiz…",
      "error": "Could not create the quiz. Please try again.",
      "edit": "Edit quiz",
      "invited": "Invited",
      "completed": "Completed",
      "taker": "Taker",
      "status": "Status",
      "notCompleted": "Not completed",
      "noTakers": "No one has been invited yet."
    },
    "documentTab": {
      "availableTitle": "Quiz available",
      "availableDescription": "Take the quiz for this document.",
      "take": "Go to quiz",
      "completedTitle": "Quiz completed",
      "completedDescription": "You answered every question correctly."
    },
    "columns": {
      "title": "Document",
      "createdBy": "Created by",
      "createdAt": "Created",
      "owner": "Owner",
      "publisher": "Publisher",
      "publishedAt": "Published",
      "adoptedAt": "Adopted",
      "tags": "Tags",
      "takers": "Completed / invited"
    },
    "actions": {
      "inviteTakers": "Invite takers",
      "createQuizzes": "Create quizzes"
    },
    "empty": {
      "unanchored": "No unanchored documents.",
      "anchored": "No anchored documents.",
      "mine": "You have not been invited to any quizzes."
    },
    "invite": {
      "title": "Invite takers",
      "description_one": "Invite users to the selected quiz.",
      "description_other": "Invite users to {{count}} selected quizzes.",
      "success": "Takers invited"
    },
    "create": {
      "title": "Create quizzes",
      "description": "A quiz is generated for each chosen document. Add an optional prompt to focus the questions, or remove documents you don't want.",
      "promptPlaceholder": "Optional: what should the questions focus on?",
      "create": "Create quizzes",
      "error_one": "A quiz could not be created. You can try again.",
      "error_other": "{{count}} quizzes could not be created. You can try again.",
      "removeDocument": "Remove document"
    },
    "quiz": {
      "back": "Back to anchoring",
      "takeQuiz": "Take quiz",
      "viewDocument": "View document",
      "notFound": "This quiz could not be found.",
      "take": {
        "progress": "Question {{current}} of {{total}}",
        "incorrect": "That's not right. Try another answer.",
        "reasonHeading": "Why this is correct",
        "next": "Next question",
        "finish": "Finish",
        "error": "Could not record your completion. Please try again.",
        "alreadyCompletedTitle": "You've completed this quiz",
        "alreadyCompletedDescription": "You answered every question correctly, so there's nothing left to do.",
        "backToList": "Back to your quizzes"
      },
      "edit": {
        "questionLabel": "Question {{number}}",
        "questionPlaceholder": "Question text",
        "optionPlaceholder": "Answer option",
        "reasonLabel": "Reason (shown after a correct answer)",
        "reasonPlaceholder": "Add a plain-text reason, or leave empty for none.",
        "removeReason": "Remove reason",
        "addOption": "Add option",
        "addQuestion": "Add question",
        "save": "Save quiz",
        "saved": "Quiz saved",
        "error": "Could not save the quiz. Please try again.",
        "optionsLabel": "Answer options (select the correct one)",
        "correctOption": "Mark option {{number}} as correct",
        "removeOption": "Remove option",
        "removeQuestion": "Remove question"
      }
    }
  }
}
